import styled from 'styled-components';
import { rem } from 'polished';
import { media } from 'core/layout';

export const StyledBanner = styled.div`
  height: ${rem(400)};

  ${media.tablet`
    height: ${rem(284)};
  `};

  ${media.tabletSmall`
    height: ${rem(168)};
  `};
`;



// WEBPACK FOOTER //
// ./src/pages/Kategorija/components/Banner/styled.js